import router from './router'
import App from './App.vue'

let Vue = dokan_get_lib('Vue');

new Vue({
    el: '#dokan-vue-seller-badge',
    router,
    render: h => h(App),
    created() {
        if ( dokan.dokan_pro_i18n ) {
            this.setLocaleData( dokan.dokan_pro_i18n['dokan'] );
        }
    },
});


